<div
  class="progress-bar-container"
  (click)="cancelLoading()"
  @stepFadeIn
  *ngIf="isLoading | async"
>
  <mat-progress-bar
    color="primary"
    mode="indeterminate"
    id="app-routing-progress-bar"
  />
</div>

<router-outlet/>
